var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"banner__footer"},[_c('img',{attrs:{"src":require("../../assets/icons/icon-target-dark.svg"),"alt":"icon lab","title":"icon lab","height":"40px"}}),_c('p',[_vm._v(" Convierte tus ideas en proyectos utilizando nuestra "),_c('b',[_vm._v("experiencia conjunta de mas de 30 años formulando proyectos éxitosos")]),_vm._v(". ")])])])
}]

export { render, staticRenderFns }